import { css } from 'styled-components';

export const smFont = css`
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.2px;
`;
